<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" :class="modalClass">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <form v-if="!loading && !successMessage && !errorMessage" @submit.prevent="submitForm">
            <div class="alert alert-info" role="alert">
              <strong>Formato del CSV requerido:</strong>
              <p class="mb-1 mt-2">El archivo debe contener las siguientes cabeceras:</p>
              <ul class="mb-0">
                <li><code>IDSEPA</code> - ID del XML generado para las transferencias</li>
                <li><code>IDTRANSFERS</code> - ID de cada transferencia individual</li>
                <li><code>LEGALIDENTIFIER</code> - Documento de identidad</li>
                <li><code>STATUS</code> - Estado: <code>CONFIRMED</code> o <code>RETURN_TRANSFERS</code></li>
              </ul>
            </div>

            <div class="form-group">
              <label for="walletCsvFile">Adjuntar CSV con transferencias:</label>
              <input type="file" class="form-control" id="walletCsvFile" accept=".csv" @change="handleFileUpload" required>
              <small v-if="fileSizeError" class="text-danger">El archivo es demasiado grande. Máximo 5MB.</small>
              <small v-if="fileTypeError" class="text-danger">Por favor, selecciona un archivo CSV válido.</small>
              <small v-if="headerError" class="text-danger">Las cabeceras del CSV no coinciden con el formato esperado. Cabeceras requeridas: <code>idSepa,idTransfers,legalIdentifier,confirmed</code></small>
            </div>
            <button type="submit" class="btn btn-primary" :disabled="fileSizeError || fileTypeError || headerError">ENVIAR</button>
          </form>

          <div v-if="successMessage" class="alert alert-success text-center">
            {{ successMessage }}
          </div>

          <div v-if="errorMessage" class="alert alert-danger text-center">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    modalTitle: String,
    modalClass: String
  },
  data() {
    return {
      csvFile: null,
      fileSizeError: false,
      fileTypeError: false,
      headerError: false,
      loading: false,
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.fileTypeError = false;
      this.fileSizeError = false;
      this.headerError = false;
      this.csvFile = null;

      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.fileTypeError = true;
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.fileSizeError = true;
        return;
      }

      this.validateCsvHeaders(file);
    },
    validateCsvHeaders(file) {
      const expectedHeaders = ['idsepa', 'idtransfers', 'legalidentifier', 'confirmed'];
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const firstLine = text.split(/\r?\n/)[0].replace(/^\uFEFF/, '').trim();
        const separator = firstLine.includes(';') ? ';' : ',';
        const headers = firstLine.split(separator).map(h => h.trim().toLowerCase());
        if (headers.length !== expectedHeaders.length ||
            !expectedHeaders.every((h, i) => headers[i] === h)) {
          this.headerError = true;
        } else {
          this.csvFile = file;
        }
      };
      reader.readAsText(file);
    },
    submitForm() {
      if (this.csvFile && !this.fileSizeError && !this.fileTypeError && !this.headerError) {
        this.loading = true;
        const formData = new FormData();
        formData.append('csv', this.csvFile);

        this.$emit('submitForm', { formData });
      }
    },
    closeModal() {
      this.resetForm();
      this.$emit('close');
    },
    resetForm() {
      this.csvFile = null;
      this.fileSizeError = false;
      this.fileTypeError = false;
      this.headerError = false;
      this.loading = false;
      this.successMessage = '';
      this.errorMessage = '';
      const fileInput = document.getElementById('walletCsvFile');
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.25rem;
  color: #97055D;
}
</style>
